import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

import { classNames } from "@/react/helpers/twMergeWithCN";

import type { ActivityScore, ScoreTypes } from "../utils";
import { getScoreIcon } from "../utils";
import { Container } from "./Container";

const scoreStyle: Record<ScoreTypes, string> = {
  high: "border-success bg-success-light text-success",
  medium: "border-warning bg-warning-light text-warning",
  low: "border-danger bg-danger-light text-danger",
  disabled: "border-primary bg-primary text-primary",
};

export const ScoreChip = ({
  activityScore,
  className,
}: {
  activityScore: ActivityScore;
  className?: string;
}) => {
  const icon = getScoreIcon(activityScore.activity);

  const contentToRender = (activityScore: ActivityScore) => {
    if (activityScore.score !== undefined) {
      return activityScore.score;
    }
    return activityScore.label;
  };

  return (
    <Container
      className={classNames(scoreStyle[activityScore.activity], className)}
      useCompassStyles
    >
      <Icon className="!w-4" type={icon} aria-hidden size={16} />
      <Typography.LabelXs weight="medium" color="text-default">
        {contentToRender(activityScore)}
      </Typography.LabelXs>
    </Container>
  );
};
